


























































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../lib/ajax'
import AbpBase from '../../lib/abpbase'
@Component
export default class AdvancedSearch extends AbpBase  {
    @Prop({}) advancedSearchType:any;
    //高级搜索组件
    //父级方法：
    //AdvancedSearch，参数为搜索数据对象
    //ClearSearch，清空搜索条件
	initData:any = {
        status: false,
        formData: {},      
        dicData: {},
        mapping: [undefined, false, true],
        scientficDate:[],//合同期限
    }
    async GetDic() {
        //所有字典
        await this.$store.dispatch('project/GetAllDictionary');
        //单位字典
        await this.$store.dispatch('project/GetbearerUnit');
        //获取所有用户数据
        await this.$store.dispatch('project/GetAllUser');
        //业务领域一级
        await this.$store.dispatch('project/GetBussinessAreaAsync');
        //外协单位
        await this.$store.dispatch('project/GetAllExternalUnit');
        //二级承担部门
        await this.$store.dispatch({type: 'project/GetAllSecondOrganization'});
        this.initData.dicData.bussinessArea = this.$store.state.project.bussinessArea.map((item:any)=>{
            return {
                value: item.directoryValue,
                id: item.id,
                label: item.directoryName,
                children: [],
                loading: false
            }
        });
        this.initData.dicData.bearerUnit = this.$store.state.project.bearerUnitId;
        this.initData.dicData.userList = this.$store.state.project.userList;
        this.initData.dicData.externalUnit = this.$store.state.project.externalUnit;
        this.initData.dicData.allSecondOrganization = this.$store.state.project.allSecondOrganization;    
        this.$store.state.project.allDictionary.map((item:any) => {
            this.$set(this.initData.dicData, item.key, item.items.map((items:any) => {
                return {
                    label: items.displayName,
                    value: items.id
                }
            }));
        });
    }
    //获取指定部门下的二级部门
    async GetAssignSecondOrganization(value:any){
        await this.$store.dispatch('project/GetAssignSecondOrganization',value);
        this.$set(this.initData.dicData,'assignSecondOrganization',this.$store.state.project.assignSecondOrganization)
    }
    //业务领域下一级
    async LoadBusynessArea(item:any, callback:any) {
        item.loading = true;
        await Ajax.get('/api/services/app/SysBaseData/GetBussinessAreaByParentIdAsync', {params: {Id: item.id}}).then((res:any)=>{
            // 如果当前一级请求发现没有第二级数据，设置childs为false，用于阻止第二次加载
            if(res.data.result.items.length == 0) {
                item.children = [{                    
                    label: '全部',
                    value: undefined
                }]
                item.loading = false;
                callback();
                return;
            }
            // 如果有数据，缓存当前的二级数据
    		item.children = res.data.result.items.map((obj:any) => {
            	return {
            		id: obj.id,
            		label: obj.directoryName,
            		value: obj.directoryValue
            	}
           	});
            item.loading = false;
            callback();
        }).catch(() => {
        	item.loading = false;
       	})
    }
    Show(status:boolean) {
        this.initData.status = status;
    }
    Search(){
        console.log(this.advancedSearchType,this.initData.formData)
        if(this.advancedSearchType == 'contract'){
            this.initData.formData.IsReceivableFinish = this.initData.mapping[this.initData.formData.IsReceivableFinishNum];
            if(this.initData.formData.IsReportStampedNum == 0){
                this.initData.formData.IsReportStamped = false;
            }else if(this.initData.formData.IsReportStampedNum == 1){
                this.initData.formData.IsReportStamped = true;
            }
        }else if(this.advancedSearchType == 'contractOutsideList'){
            
        }else if(this.advancedSearchType.type == 'project'){
            this.initData.formData.OnlyBuilding = this.initData.mapping[this.initData.formData.ProjectStatus];
            this.initData.formData.IsReceivableFinish = this.initData.mapping[this.initData.formData.IsReceivableFinishNum];
            this.initData.formData.BusynessArear1 = this.initData.formData.BusynessArea ? this.initData.formData.BusynessArea[0] : undefined;
            this.initData.formData.BusynessArear2 = this.initData.formData.BusynessArea ? this.initData.formData.BusynessArea[1] : undefined;
            this.initData.formData.SignYear = this.initData.formData.SignDate ? this.initData.formData.SignDate.getFullYear() : undefined;
        }else if(this.advancedSearchType == 'scientfic'){
            this.initData.formData.ContractBeginDt = this.initData.scientficDate[0]?new Date(this.initData.scientficDate[0]):null;//合同开始日期
            this.initData.formData.ContractEndDt = this.initData.scientficDate[1]?new Date(this.initData.scientficDate[1]):null;//合同结束日期
        }
        (this as any).$parent.AdvancedSearch(this.initData.formData);
    }
    Rest(){
        for( let index in (this.$refs as any)){
             (this.$refs as any)[index].clearSingleSelect();
        }
        this.initData.formData = {};
        if(this.advancedSearchType == 'scientfic'){
            this.initData.scientficDate = [];
        }
        (this as any).$parent.ClearSearch();
    }
    mounted() {
        this.GetDic();
    }
    @Watch('advancedSearchType.data.BearerOrgId')
    BearerOrgIdChange(newVal:any, oldVal:any){
        if((newVal != '-999' && newVal != null && newVal != undefined) ){
            this.initData.formData.SecondBearerOrgId = '';
            this.GetAssignSecondOrganization(newVal);
        }else{
            this.$set(this.initData.dicData,'assignSecondOrganization',this.$store.state.project.allSecondOrganization);
        }
    }

}
